import React, { useContext, useEffect, useState } from 'react';
import UserDetailsContext from '../context/userDetails.context';
import LocationsContext from '../context/locations.Context';
import ThemeContext from '../context/theme.Context';
import NotificationContext from '../context/notification.Context';
import { withRouter } from "react-router";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Dropdown from 'react-bootstrap/Dropdown';
import SplitButton from 'react-bootstrap/SplitButton';
import Alert from 'react-bootstrap/Alert';
import { LinkContainer } from 'react-router-bootstrap';
import Spinner from './Spinner.component';

import iconSvg from '../images/icon.svg';


const NavMenu = (props) => {

    const { showMessage, serverUnreachable } = useContext(NotificationContext);

    const { userId, token } = useContext(UserDetailsContext);

    const { locations, activeLocationId, setActiveLocationId } = useContext(LocationsContext);

    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [installButtonVisible, setInstallButtonVisible] = useState(false);

    useEffect(() => {

        function showNotification(e) {
            showMessage({ newMessage: e.detail });
        }

        window.addEventListener("serviceWorkerEvent", showNotification);

        window.addEventListener('beforeinstallprompt', (e) => {
            // Prevent Chrome 67 and earlier from automatically showing the prompt
            e.preventDefault();
            // Stash the event so it can be triggered later.
            setDeferredPrompt(e);
            // Make the install button visible:
            setInstallButtonVisible(true);
        });

        return () => {
            window.removeEventListener("serviceWorkerEvent", showNotification);
        };
    });

    function installApp() {
        if (!deferredPrompt)
            return;

        // Hide the install button:
        setInstallButtonVisible(false);
        // Show the prompt
        deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        deferredPrompt.userChoice
            .then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('User accepted the A2HS prompt');
                } else {
                    console.log('User dismissed the A2HS prompt');
                }
                setDeferredPrompt(null);
            });
    }

    function activeLocation() {

        var loc;
        var locId;
        locId = activeLocationId;
        if (locations) {
            if (!locId || locId === 0) {
                locId = Object.values(locations)[0].id;
            }
            loc = locations[locId.toString()];
        }
        if (!loc) {
            loc = { id: "0", name: 'Unknown', owner: '', authorization: '' };
        }
        return loc;
    }

    function activeMenuKey() {
        var ret;

        if (window.location.pathname === '/locations')
            ret = '/locations';
        else
            ret = activeLocation().id;
        return ret;
    }
    function locationKey(locationId) {
        return locationId;
    }

    function selectLocation(eventKey, event) {
        // Selected a location, so set active location ID and redirect to the locations component:
        setActiveLocationId(eventKey.toString());
        redirectTo('/');
    }

    function redirectTo(loc) {
        if (window.location.pathname !== loc) {
            props.history.push(loc);
        }
    }

    return (
        !token
            ? <React.Fragment />
            :
            <ThemeContext.Consumer>
                {(themeContext) => (
                    <Navbar bg={themeContext.theme} variant={themeContext.theme} style={{ paddingLeft: '6px', paddingRight: '6px' }}>
                        <Nav className="mr-auto" variant="pills" activeKey={activeMenuKey()}>
                            <SplitButton variant={themeContext.theme} title={activeLocation().name} id="locations-dropdown" onClick={(e) => redirectTo('/')}>
                                {locations && Object.values(locations).map(location => (
                                    <NavDropdown.Item onSelect={(e) => selectLocation(e)} key={locationKey(location.id)} eventKey={locationKey(location.id)}>
                                        {location.name}
                                    </NavDropdown.Item>
                                ))}
                                <Dropdown.Divider key='divider' />
                                <NavDropdown.Item key="manageLocations" onSelect={(e) => redirectTo('/locations')} eventKey="manageLocations">
                                    Manage locations
                                </NavDropdown.Item>
                            </SplitButton>
                        </Nav>
                        <Nav variant="pills">
                            <Spinner />
                        </Nav>
                        <NotificationContext.Consumer>
                            {(notificationContext) => (

                                <Nav className='flex-grow-1'>
                                    <Navbar.Text className='flex-grow-1'>
                                        {' '}<Alert key='MainAlert' variant={themeContext.theme} show={notificationContext.visible} dismissible onClose={() => { notificationContext.hideMessage(); }}>
                                            <FontAwesomeIcon icon="bell" />
                                            {' '}
                                            {notificationContext.message}

                                        </Alert>
                                    </Navbar.Text>
                                </Nav>

                            )}
                        </NotificationContext.Consumer >

                        <Nav className="ml-auto">
                            {installButtonVisible &&
                                <Nav.Item>
                                    <Button variant={themeContext.theme} title='Install app' onClick={installApp}><FontAwesomeIcon icon="download" /></Button>
                                </Nav.Item>
                            }
                            <LinkContainer to={'/profile'}>
                                <Nav.Item>
                                    <Button variant={themeContext.theme}><img src={iconSvg} width='16px' alt="Logo"/></Button>
                                </Nav.Item>
                            </LinkContainer>
                            {((activeLocation().owner === userId || activeLocation().authorization === 'Manage') && !serverUnreachable) ?
                                <React.Fragment>
                                    <LinkContainer to={'/addDevice'}>
                                        <Nav.Item>
                                            <Button variant={themeContext.theme}><FontAwesomeIcon icon="plus-square" /></Button>
                                        </Nav.Item>
                                    </LinkContainer>
                                </React.Fragment>
                                :
                                serverUnreachable ?
                                    <Button variant='secondary' disabled><FontAwesomeIcon icon="plus-square" /></Button>
                                    :
                                    <Button variant={themeContext.theme} disabled><FontAwesomeIcon icon="plus-square" /></Button>

                            }
                        </Nav>

                    </Navbar>
                )}
            </ThemeContext.Consumer>

    );
};

export default withRouter(NavMenu);



// WEBPACK FOOTER //
// ./src/components/NavMenu.js